import { render, staticRenderFns } from "./Horses.vue?vue&type=template&id=edc7261c&scoped=true"
import script from "./Horses.vue?vue&type=script&lang=js"
export * from "./Horses.vue?vue&type=script&lang=js"
import style0 from "./Horses.vue?vue&type=style&index=0&id=edc7261c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc7261c",
  null
  
)

export default component.exports